import type { components } from '@pba/types-openapi-client';
import { Avatar, Link, Text } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useGetUserNameWithFallback } from 'features/users/hooks';

type P = {
  member: components['schemas']['UserList'];
};

/**
 * @deprecated Use direct member row implementation instead
 */
const CommunityMemberRow = ({ member }: P) => {
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const fullName = getUserNameWithFallback({ firstName: member.first_name, lastName: member.last_name });

  return (
    <div className="community-member-row">
      <div className="community-member-row__avatar">
        <Link style={{ textDecoration: 'inherit' }} to={`/members/${member.id}`}>
          <Avatar photo={member.profile_photo?.url}>{fullName}</Avatar>
        </Link>
      </div>
      <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
        <Link style={{ textDecoration: 'inherit' }} to={`/members/${member.id}`}>
          <Text>{fullName}</Text>
        </Link>
      </div>
    </div>
  );
};

export default CommunityMemberRow;
